import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import ApplianceCard from '../components/appliances/ApplianceCard';

const CATEGORY_LABELS = {
  hvac: 'HVAC',
  'water-heater': 'Water Heater',
  washer: 'Washer',
  dryer: 'Dryer',
  dishwasher: 'Dishwasher',
  refrigerator: 'Refrigerator',
  oven: 'Oven',
  other: 'Other',
};

const Appliances = () => {
  const { appliances, fetchAppliances, loading } = useApp();

  useEffect(() => { fetchAppliances(); }, [fetchAppliances]);

  const byCategory = appliances.reduce((acc, a) => {
    if (!acc[a.category]) acc[a.category] = [];
    acc[a.category].push(a);
    return acc;
  }, {});

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h1>Appliances</h1>
        <Link to="/appliances/new" className="btn btn-primary">+ Add Appliance</Link>
      </div>

      {appliances.length === 0 ? (
        <p className="empty-state">
          No appliances yet. <Link to="/appliances/new">Add your first appliance.</Link>
        </p>
      ) : (
        Object.entries(byCategory).map(([category, items]) => (
          <section key={category}>
            <h2>{CATEGORY_LABELS[category] || category}</h2>
            <div className="card-grid">
              {items.map((a) => <ApplianceCard key={a._id} appliance={a} />)}
            </div>
          </section>
        ))
      )}
    </div>
  );
};

export default Appliances;
